const removeClassNameByPrefix = (className, prefix) =>
  className
    .split(' ')
    .filter((item) => !item.startsWith(prefix))
    .join(' ');

export default removeClassNameByPrefix;
